import { serviceInstance } from 'libs';

export default {
  updateAccountDetails: (details, id) =>
    serviceInstance
      .post(`/api/merchant/${id}/bank`, details)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  fetchAccountDetails: (id) =>
    serviceInstance
      .get(`/api/merchant/${id}/banks`)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),

  lookupSettlement: (merchantId, date) =>
    serviceInstance.get(
      `/settlements/merchants/${merchantId}/revenue?from=${date.from}&to=${date.to}`,
    ),
  withdrawSettlement: (merchantId, body) =>
    serviceInstance.post(
      `settlements/merchants/${merchantId}/withdrawal`,
      body,
    ),
};
